import { createRoot } from 'react-dom/client';

// style.scss
import 'assets/style.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';


import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';

// After a new deploy, old hashed chunks are removed from the CDN. A browser still
// running the previous index.html will fail to lazy-load a now-missing chunk.
// Vite fires `vite:preloadError` — reload once (throttled) to pull fresh assets.
const reloadOnStaleChunk = () => {
  const key = 'chunkReloadAt';
  const last = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(key, String(Date.now()));
    window.location.reload();
  }
};
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadOnStaleChunk();
});
// Fallback for browsers/paths that surface it as an unhandled rejection.
window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || '';
  if (/dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(msg)) {
    reloadOnStaleChunk();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
